export default function About() {
  return (
    <section id="about" className="py-12 sm:py-20 bg-[#F5F3EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-4xl font-bold text-center mb-4 sm:mb-6 text-gray-800">
          会社概要
        </h2>
        <p className="text-center text-sm sm:text-base text-gray-600 mb-10 sm:mb-16 max-w-3xl mx-auto leading-relaxed">
          大阪府下をはじめ、近畿一円にハウスクリーニングを通じて、数多くのお客様から信頼され、今ここに至ることとなりました。<br className="hidden sm:block" />
          住空間の「安心で快適」な提供を使命と考え、これからも、お客様ひとりひとりに添った、サービスプランをご提供致します。
        </p>

        {/* サービス紹介 */}
        <div className="mb-12 sm:mb-20">
          <h3 className="text-xl sm:text-2xl font-bold text-center mb-8 sm:mb-12 text-gray-800">
            Service of refresh labo
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://static.wixstatic.com/media/87f369_1d9720a06a134adfbd3a21297ea39aa8~mv2.jpeg/v1/fill/w_460,h_340,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/8FC09DDD-AB5B-4F11-AAB6-EF15A7EABB5D.jpeg"
                  alt="在宅ハウスクリーニング"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  在宅ハウスクリーニング
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  お風呂、キッチン、換気扇などの水回り清掃や、エアコン洗浄や外壁清掃など様々な御要望にお答え致します。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://static.wixstatic.com/media/87f369_feb33ef0c5184e35b3e598b6c9bf9f4e~mv2.jpeg/v1/fill/w_460,h_360,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Untitled.jpeg"
                  alt="原状回復工事・空室清掃"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  原状回復工事・空室清掃
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  管理会社様、オーナー様、工務店様など、多岐にわたるお客様からご依頼を得て、入居者の方が快適に過ごして頂けるよう、工事させて頂きます。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://static.wixstatic.com/media/87f369_c8eac029dde74c4a8b166cb9ab49905e~mv2.jpeg/v1/fill/w_460,h_360,al_c,lg_1,q_80,enc_avif,quality_auto/Untitled.jpeg"
                  alt="マンション日常・定期清掃"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  マンション日常・定期清掃
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  マンションなどを所有、各施設を所有されているオーナー様や管理会社様からの御依頼を受け、建物の景観を維持させて頂いております。御依頼はメールまたはお電話にて承ります。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://public.readdy.ai/ai/img_res/5bb02dcd5dc671b36de421e2a014f9c8.jpg"
                  alt="遺品整理事業"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  遺品整理事業
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  故人様の大切な遺品を丁寧に整理・仕分けいたします。ご遺族様のお気持ちに寄り添い、真心を込めて対応させていただきます。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20property%20inspection%20agent%20in%20business%20attire%20checking%20apartment%20room%20condition%20with%20clipboard%20taking%20notes%20examining%20walls%20and%20floors%20of%20empty%20rental%20unit%20bright%20clean%20modern%20Japanese%20apartment%20interior%20soft%20natural%20lighting%20from%20window%20minimalist%20background&width=460&height=360&seq=tachiai001&orientation=portrait"
                  alt="退去立会い代行"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  退去立会い代行
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  入居者様の退去時に、国交省ガイドラインに基づき室内の損耗状況を確認・記録。原状回復費用の負担区分を公正に判定し、精算書作成から鍵の回収まで一括で代行いたします。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20high%20rise%20building%20window%20cleaning%20workers%20on%20scaffolding%20washing%20glass%20exterior%20of%20tall%20modern%20office%20building%20in%20Japanese%20city%20clear%20blue%20sky%20bright%20daylight%20urban%20cityscape%20background%20safety%20harness%20equipment%20visible%20clean%20professional%20atmosphere&width=460&height=360&seq=highglass001&orientation=portrait"
                  alt="高所ガラス清掃"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  高所ガラス清掃
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  高所ビルやオフィスなどご相談ください。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-56 sm:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20technician%20cleaning%20large%20commercial%20ceiling%20mounted%20air%20conditioning%20unit%20in%20Japanese%20office%20space%20using%20specialized%20tools%20and%20equipment%20white%20clean%20interior%20bright%20fluorescent%20lighting%20modern%20office%20environment%20maintenance%20work%20in%20progress&width=460&height=360&seq=commercialac001&orientation=portrait"
                  alt="業務用エアコン洗浄"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h4 className="text-base sm:text-xl font-bold mb-2 sm:mb-3 text-gray-800">
                  業務用エアコン洗浄
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  オフィスや店舗など何方向でも対応可能です。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 会社詳細情報 */}
        <div className="bg-white rounded-lg shadow-sm p-5 sm:p-8 md:p-12 max-w-5xl mx-auto">
          <h3 className="text-xl sm:text-2xl font-bold mb-6 sm:mb-8 text-gray-800 text-center">
            会社情報
          </h3>
          <dl className="space-y-4 sm:space-y-6">
            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                会社名
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                株式会社Refresh Labo
              </dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                所在地
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                〒558-0002<br />
                大阪府大阪市住吉区長居西1-12-36
              </dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                電話番号
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                TEL: 090-2438-6991
              </dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                営業時間
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">8:00-18:00</dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                定休日
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">日曜日・祝日</dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                創業
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">2020年9月</dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                設立
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">2025年7月</dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                代表者
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                代表取締役 田島大樹
              </dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                資本金
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">100万円</dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                従業員数
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">8人（パート・アルバイト含む）</dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                事業内容
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                <ul className="list-disc list-inside space-y-1 sm:space-y-2 ml-2">
                  <li>在宅ハウスクリーニング（水回り清掃、エアコン洗浄、外壁清掃等）</li>
                  <li>原状回復工事・空室清掃</li>
                  <li>マンション日常・定期清掃</li>
                  <li>遺品整理事業</li>
                  <li>退去立会い代行</li>
                  <li>高所ガラス清掃</li>
                  <li>業務用エアコン洗浄</li>
                </ul>
              </dd>
            </div>

            <div className="border-b border-gray-200 pb-4 sm:pb-6">
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                取引銀行
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                GMOあおぞらネット銀行
              </dd>
            </div>

            <div>
              <dt className="text-xs sm:text-sm font-bold text-gray-700 mb-1 sm:mb-2">
                主な取引先
              </dt>
              <dd className="text-sm sm:text-base text-gray-800">
                <ul className="list-disc list-inside space-y-1 ml-2">
                  <li>各種不動産管理会社様</li>
                  <li>マンション管理組合様</li>
                  <li>建設会社様</li>
                  <li>個人オーナー様</li>
                </ul>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}